var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-wrapper",style:(_vm.style)},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.image),expression:"!image"}]},[_vm._v(_vm._s(_vm.initials))]),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.image),expression:"image"}],attrs:{"src":_vm.image,"alt":_vm.alt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }